import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/throw';

@Injectable()
export class SessionService {
  constructor(private router: Router, private snackBar: MatSnackBar) {}

  clearSession() {
    localStorage.removeItem('token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('tokenTTL');
    localStorage.removeItem('role');
    localStorage.removeItem('name');
    localStorage.removeItem('organisation');
    localStorage.removeItem('requires_2fa_setup');
    localStorage.removeItem('two_factor_enabled');
    localStorage.removeItem('two_factor_forced');
  }

  handleAuthenticatedRequestError(error: any) {
    const body = this.getErrorBody(error);
    const firstErrorMessage = body && body.errors && body.errors.length > 0 ?
        body.errors[0].message : null;

    if (error && error.status === 401 &&
        firstErrorMessage === 'api.errors.two_factor_code_incorrect') {
      return Observable.throw(error);
    }

    if (error && error.status === 401) {
      this.showMessage('Your session has expired. Please log in again.');
      this.clearSession();
      this.router.navigate(['/login']);
    } else if (error && error.status === 403 && body && body.requires_2fa_setup) {
      localStorage.setItem('requires_2fa_setup', 'true');
      this.router.navigate(['/two-factor']);
    } else if (error && error.status === 403) {
      this.showMessage('Your session is no longer valid. Please log in again.');
      this.clearSession();
      this.router.navigate(['/login']);
    }

    return Observable.throw(error);
  }

  private getErrorBody(error: any) {
    if (!error || !error.json) {
      return null;
    }

    try {
      return error.json();
    } catch (e) {
      return null;
    }
  }

  private showMessage(message: string) {
    this.snackBar.open(message, null, { duration: 5000 });
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/data/services/session.service.ts